// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2UkJy","assignButton":"CreateEditEquipmentSchedule_assignButton__24JYP"};